import { isNil } from 'lodash';
// Import Constants
import { POSITIVE_INTEGER_REGEXP } from 'constants/regexp';

export const isDateBiggerThanCurrentDate = (value?: Nullable<string | Date>) => {
    if (isNil(value)) return true;

    const currentDate = new Date();
    const chosenDate = new Date(value);

    return chosenDate.getTime() >= currentDate.getTime();
};

export const isPositiveInteger = (value?: Nullable<string>) => {
    if (isNil(value) || !value) return true;
    return POSITIVE_INTEGER_REGEXP.test(value);
};

export const isGreaterThan = (value?: Nullable<number>, count = 0) => {
    if (isNil(value) || isNaN(value)) return true;
    return +value >= +count;
};

interface IsInRangeParams {
    value?: Nullable<number>;
    range?: string[];
    ignoreTypes?: boolean;
}

export const isInRange = ({ value, range = [], ignoreTypes = true }: IsInRangeParams) => {
    if (isNil(value)) return true;

    if (!Array.isArray(range)) {
        throw new TypeError("Expected 'range' to be an array");
    }

    if (ignoreTypes) {
        return range.map(Number).includes(+value);
    }

    return range.includes(`${value}`);
};
